import React from 'react';
import { PendingConfirmation } from '../types';

interface ConfirmationDialogProps {
  pendingConfirmation: PendingConfirmation;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ pendingConfirmation, isLoading, onConfirm, onCancel }) => {
  return (
    <div className="flex gap-2.5 mb-3">
      <div className="w-7 h-7 bg-amber-500 rounded-lg flex items-center justify-center shrink-0 mt-0.5">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <div className="bg-amber-50 border border-amber-200 px-3.5 py-2.5 rounded-2xl rounded-tl-md max-w-[90%]">
          <div className="flex items-center gap-1.5 mb-1.5">
            <span className="text-[9px] font-bold text-amber-700 uppercase tracking-wider">Confirmation Required</span>
          </div>
          <p className="text-[12px] text-slate-700 mb-2 leading-relaxed">{pendingConfirmation.message}</p>
          <p className="text-[10px] text-slate-400 mb-2.5">
            Expires: {new Date(pendingConfirmation.expiresAt).toLocaleTimeString()}
          </p>
          <div className="flex gap-2">
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="px-3.5 py-1.5 bg-slate-800 text-white text-[11px] font-medium rounded-lg hover:bg-emerald-600 transition-all disabled:opacity-50"
            >
              {isLoading ? 'Executing...' : 'Confirm'}
            </button>
            <button
              onClick={onCancel}
              disabled={isLoading}
              className="px-3.5 py-1.5 bg-white border border-slate-200 text-slate-500 text-[11px] font-medium rounded-lg hover:bg-slate-50 transition-all disabled:opacity-50"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ConfirmationDialog);
